export const ImportMode = {
  ASIN: 'asin',
  CSV: 'csv'
} as const;
export type ImportModeType = (typeof ImportMode)[keyof typeof ImportMode];
